import React from 'react';
import './Arrow.scss';

function Arrow({ location }) {
  return (
    <svg
      className={location === 'cta' ? 'arrow arrow-cta' : 'arrow arrow-nav'}
      viewBox="0 0 12 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 1.04785L9.5 6.04785L1.5 11.0479"
        className={location === 'cta' ? 'arrow__path' : 'arrow__path arrow__path-nav'}
      />
    </svg>
  );
}

export default Arrow;
